/* Vemorina homepage — onthul-bij-scroll (ontwerp about-strip.html):
   kaarten/tegels/koppen faden in met 16px lift zodra ze in beeld komen.
   De klasse wordt uitsluitend via JS gezet, dus zonder JS blijft alles
   gewoon zichtbaar; prefers-reduced-motion = geen animatie.
   LET OP: binnen zijwaarts-scrollbare rijen (mm/gm/rv/tl/ug) staat de
   animatie op de RIJ, nooit op de kaarten erin — een translateY op een
   kind van een x-scroll-container maakt die container ook verticaal
   scrollbaar (overflow-x:auto ⇒ overflow-y wordt auto). */
(function () {
  if (window.__vmHpReveal) return;
  window.__vmHpReveal = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll(
    '.vm-hp-pb__card, .vm-hp-mm__header, .vm-hp-mm__grid, .vm-hp-vl__card,' +
    ' .vm-hp-gm__cards, .vm-hp-rv__header, .vm-hp-rv__grid, .vm-hp-cs__card,' +
    ' .vm-hp-tl__header, .vm-hp-tl__grid, .vm-hp-vh__card, .vm-hp-vh__tile,' +
    ' .vm-hp-ug__header, .vm-hp-ug__strip, .vm-hp-af__card'
  );
  if (!targets.length) return;

  /* Opruim-fix 2026-07-21 (5-sporen-onderzoek eind-tik): .vm-hp-reveal droeg
     zijn transition op transform PERMANENT — elke latere animatie op hetzelfde
     element (zoals de swipe-hint) kreeg daardoor bij class-wissels een verse
     0,55s-transitie als zichtbare tik. Na de reveal worden beide classes
     verwijderd; de kale basis is identiek aan de eindstaat (opacity 1,
     transform none), dus het opruimen zelf is onzichtbaar. */
  function schoonOp(el) {
    var klaar = function (ev) {
      if (ev && ev.target !== el) return;
      el.removeEventListener('transitionend', klaar);
      clearTimeout(vangnet);
      el.classList.remove('is-revealed');
      el.classList.remove('vm-hp-reveal');
    };
    el.addEventListener('transitionend', klaar);
    var vangnet = setTimeout(klaar, 700); /* transition duurt 0,55s */
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
        schoonOp(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

  targets.forEach(function (el) {
    el.classList.add('vm-hp-reveal');
    observer.observe(el);
  });
})();
